exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-area[data-v-118c250a]{position:relative;margin:auto;height:400px}.ps__thumb-x[data-v-118c250a],.ps__thumb-y[data-v-118c250a]{background-color:#00d1b2;width:10px}.div_scroll[data-v-118c250a]{margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-118c250a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/Tipos.vue
// module id = 2155
// module chunks = 0